// extracted by mini-css-extract-plugin
module.exports = {"blockTotal":"styles_blockTotal__bvVp0","scrollbars":"styles_scrollbars__rao1d","slideInSearchBar":"styles_slideInSearchBar__mETp_"};